// localStorageHelper.js
export const saveSearchState = (query, movieList, page, totalResults) => {
  const state = { query, movieList, page, totalResults }
  localStorage.setItem("searchState", JSON.stringify(state))
}

export const loadSearchState = () => {
  const state = localStorage.getItem("searchState")
  return state ? JSON.parse(state) : null
}
